import script from "./GoHome.vue?vue&type=script&setup=true&lang=js"
export * from "./GoHome.vue?vue&type=script&setup=true&lang=js"

import "./GoHome.vue?vue&type=style&index=0&id=30397b5e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30397b5e"]])

export default __exports__